import { createAsyncThunk } from '@reduxjs/toolkit';
import { IRoleList } from './types';
import apiCall from '../../utils/api';

export const fetchRoleList = createAsyncThunk(
  'role/fetchRoleList',
  async ({ page, pageSize, search }: { page: number; pageSize: number; search: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: IRoleList }>('get', `/auth/role/search/?page=${page}&page_size=${pageSize}&search=${search}`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch role list');
    }
  }
);